import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M790.705882,338.823529 L790.705882,451.764706 L395.411765,451.764706 C364.352941,451.764706 338.941176,477.063529 338.941176,508.235294 L338.941176,508.235294 L338.941176,1252.74353 C356.672941,1246.41882 375.534118,1242.35294 395.411765,1242.35294 L395.411765,1242.35294 L1524.82353,1242.35294 C1544.70118,1242.35294 1563.56235,1246.41882 1581.29412,1252.74353 L1581.29412,1252.74353 L1581.29412,508.235294 C1581.29412,477.063529 1555.88235,451.764706 1524.82353,451.764706 L1524.82353,451.764706 L1129.52941,451.764706 L1129.52941,338.823529 L1524.82353,338.823529 C1618.22588,338.823529 1694.23529,414.832941 1694.23529,508.235294 L1694.23529,508.235294 L1694.23529,1750.58824 C1694.23529,1843.99059 1618.22588,1920 1524.82353,1920 L1524.82353,1920 L395.411765,1920 C302.009412,1920 226,1843.99059 226,1750.58824 L226,1750.58824 L226,508.235294 C226,414.832941 302.009412,338.823529 395.411765,338.823529 L395.411765,338.823529 L790.705882,338.823529 Z M1524.82353,1355.29412 L395.411765,1355.29412 C364.352941,1355.29412 338.941176,1380.59294 338.941176,1411.76471 L338.941176,1411.76471 L338.941176,1750.58824 C338.941176,1781.76 364.352941,1807.05882 395.411765,1807.05882 L395.411765,1807.05882 L1524.82353,1807.05882 C1555.88235,1807.05882 1581.29412,1781.76 1581.29412,1750.58824 L1581.29412,1750.58824 L1581.29412,1411.76471 C1581.29412,1380.59294 1555.88235,1355.29412 1524.82353,1355.29412 L1524.82353,1355.29412 Z M1016.62212,-0.0225882353 L1016.62212,880.128 L1262.83388,633.803294 L1342.68329,713.652706 L960.151529,1096.29741 L577.506824,713.652706 L657.356235,633.803294 L903.680941,880.128 L903.680941,-0.0225882353 L1016.62212,-0.0225882353 Z M564.823529,1468.23529 C502.48,1468.23529 451.882353,1518.94588 451.882353,1581.17647 C451.882353,1643.40706 502.48,1694.11765 564.823529,1694.11765 C627.167059,1694.11765 677.764706,1643.40706 677.764706,1581.17647 C677.764706,1518.94588 627.167059,1468.23529 564.823529,1468.23529 L564.823529,1468.23529 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSaveLine = /*#__PURE__*/function (_Component) {
  _inherits(IconSaveLine, _Component);

  var _super = _createSuper(IconSaveLine);

  function IconSaveLine() {
    _classCallCheck(this, IconSaveLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconSaveLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSave",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconSaveLine.displayName = "IconSaveLine";
  return IconSaveLine;
}(Component);

IconSaveLine.glyphName = 'save';
IconSaveLine.variant = 'Line';
IconSaveLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSaveLine;
export { IconSaveLine };